import { PaginatedRequest } from '@/app/common/utils/pagination/types';

export interface VehicleTrackerPosition {
  chassis: string;
  latitude: number;
  longitude: number;
  speed: number;
  direction?: number | null;
  ignition?: string | null;
  satelliteCount?: number | null;
  batteryLevel?: number | null;
  trackerBatteryLevel?: number | null;
  temperature?: number | null;
  engineRpm?: number | null;
  recordedAt: string;
  receivedAt: string;
}

export interface VehicleTrackerSummary {
  totalVehicles: number;
  inMotion: number;
  stopped: number;
  ignitionOn: number;
  lastUpdate: string | null;
}

export type VehicleTrackerPositionFindAllParams = PaginatedRequest;

export interface VehicleTrackerMovementFindAllParams extends PaginatedRequest {
  from?: string;
  to?: string;
}

export interface VehicleTrackerStatisticsParams {
  from: string;
  to: string;
}

export interface VehicleTrackerTrailPoint {
  latitude: number;
  longitude: number;
  recordedAt: string;
}

export interface VehicleTrackerStatistics {
  chassis: string;
  from: string;
  to: string;
  pointsCount: number;
  distanceKm: number;
  movingTimeSec: number;
  stoppedTimeSec: number;
  avgSpeed: number;
  maxSpeed: number;
  ignitionOnTimeSec: number;
  dataFrom: string | null;
  dataTo: string | null;
  hasPartialCoverage: boolean;
  lastPosition: VehicleTrackerPosition | null;
  trailSample: VehicleTrackerTrailPoint[];
  trailTruncated: boolean;
}

/** Dados operacionais do checklist anexados ao marker (Fase 3). */
export interface VehicleTrackerEnrichment {
  hoursMeter: number | null;
  responsibleName: string | null;
  productName: string | null;
  productImage: string | null;
  checklistDate: string | null;
  checklistStatus: string | null;
}

/** Payload ao vivo via Socket.IO (`tracker:position`). */
export interface VehicleTrackerRealtimePosition {
  chassis: string;
  latitude: number;
  longitude: number;
  speed: number;
  direction?: number | null;
  ignition?: string | null;
  satelliteCount?: number | null;
  batteryLevel?: number | null;
  trackerBatteryLevel?: number | null;
  temperature?: number | null;
  engineRpm?: number | null;
  recordedAt: string;
  receivedAt: string;
}

export const TRACKER_POSITION_TOPIC = 'tracker:position';
